import { render, staticRenderFns } from "./PollChoices.vue?vue&type=template&id=4e96dca4&"
import script from "./PollChoices.vue?vue&type=script&lang=js&"
export * from "./PollChoices.vue?vue&type=script&lang=js&"
import style0 from "./PollChoices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PollChoices.vue?vue&type=style&index=1&lang=css&"
import style2 from "./PollChoices.vue?vue&type=style&index=2&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports